import * as React from "react";

function AiSvg(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} viewBox="0 0 40 40" {...props}>
      <g fill="none" stroke="#fff" strokeWidth={2}>
        <rect width={24} height={24} x={8} y={8} rx={4} />
        <circle cx={20} cy={20} r={4} />
        <path d="M20 8v4M20 28v4M28 20h4M8 20H4" />
      </g>
    </svg>
  );
}

export default AiSvg;
